import { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Paper,
} from "@mui/material";
import { Container, Row } from "react-bootstrap";
import VN from "../components/VN";
import { UserDataContext } from "../components/UserDataContext";

// Importy Twoich komponentów
import Nanny from "./Nanny";
import Aboutme from "./Aboutme";
import Cityuser from "./Cityuser";
import Qualifications from "./Qualifications";
import Experience from "./Experience";
import Languages from "./Languages";
import Endprofile from "./Endprofile";

const steps = [
  { label: "Dane personalne", component: (reload) => <Aboutme /> },
  {
    label: "Co mogę zrobić?",
    component: (reload) => <Nanny reloadList={reload} />,
  },
  { label: "Gdzie mogę pracować?", component: (reload) => <Cityuser /> },
  {
    label: "Kwalifikacje i uprawnienia",
    component: (reload) => <Qualifications reloadList={reload} />,
  },
  { label: "Doświadczenie", component: (reload) => <Experience /> },
  { label: "Języki obce", component: (reload) => <Languages /> },
  { label: "Zakończenie edycji", component: (reload) => <Endprofile /> },
];

export default function ProfileStepper() {
  const [activeStep, setActiveStep] = useState(-1);
  const [reloadList, setReloadList] = useState(0);
  const { userData } = useContext(UserDataContext);

  useEffect(() => {
    const savedStep = localStorage.getItem("selectedTabTasks");
    if (savedStep !== null) {
      setActiveStep(parseInt(savedStep));
    }
  }, []);

  const handleNext = () => {
    const nextStep = activeStep + 1;
    setActiveStep(nextStep);
    localStorage.setItem("selectedTabTasks", nextStep);
    setReloadList((prev) => prev + 1);
  };

  const handleBack = () => {
    const prevStep = activeStep - 1;
    setActiveStep(prevStep);
    localStorage.setItem("selectedTabTasks", prevStep);
  };

  const handleStepClick = (stepIndex) => {
    const newStep = activeStep === stepIndex ? -1 : stepIndex;
    setActiveStep(newStep);
    localStorage.setItem("selectedTabTasks", newStep);
  };

  if (!userData) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ backgroundColor: "#f5f5f5", minHeight: "100vh", pb: 5 }}>
      <VN userData={userData} />

      <Container className="mt-4">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Typography variant="h5" fontWeight="700">
            Edycja profilu opiekunki
          </Typography>
          <Button
            component={Link}
            to={`/portfolio/${userData.userId}`}
            variant="contained"
            color="success"
            sx={{ borderRadius: "20px", px: 4 }}
          >
            Podgląd profilu
          </Button>
        </Box>

        <Paper elevation={3} sx={{ p: { xs: 2, md: 4 }, borderRadius: "15px" }}>
          <Stepper activeStep={activeStep} orientation="vertical" nonLinear>
            {steps.map((step, index) => (
              <Step key={step.label} expanded={activeStep === index}>
                {" "}
                {/* Dodano expanded */}
                <StepLabel
                  onClick={() => handleStepClick(index)}
                  style={{ cursor: "pointer" }}
                  sx={{
                    // Opcjonalnie: zmiana koloru tła nagłówka przy aktywnym kroku
                    py: 1,
                    "& .MuiStepLabel-label": {
                      fontSize: "1.1rem",
                      color: activeStep === index ? "primary.main" : "inherit",
                    },
                  }}
                >
                  <Typography
                    fontWeight={activeStep === index ? "bold" : "normal"}
                  >
                    {step.label}
                  </Typography>
                </StepLabel>
                <StepContent>
                  <Box sx={{ mt: 2, mb: 2 }}>
                    <Row>{step.component(reloadList)}</Row>
                  </Box>
                  {/*
                  <Box sx={{ mb: 2, display: "flex", gap: 1 }}>
                    <Button
                      variant="contained"
                      onClick={handleNext}
                      sx={{ mt: 1, mr: 1, borderRadius: "8px" }}
                      disabled={index === steps.length - 1}
                    >
                      Dalej
                    </Button>
                    <Button
                      disabled={index === 0}
                      onClick={handleBack}
                      sx={{ mt: 1, mr: 1, borderRadius: "8px" }}
                    >
                      Wstecz
                    </Button>
                  </Box>
                  */}
                </StepContent>
              </Step>
            ))}
          </Stepper>
        </Paper>
      </Container>
    </Box>
  );
}
